<template>
  <div>
    <ContentTop>
      <img
        src="../assets/images/icon.png"
        alt=""
      />
      <span> 请选择系统查重</span>
    </ContentTop>
    <div class="main step">
      <div class="query">
        <ul>
          <li>
              <div class="q">万方数据文献相似性检测系统</div>
              <div class="a">
                  万方数据文献相似性检测服务采用科学先进的检测技术，实现海量学术文献数据全文比对，秉持客观、公正、精准、全面的服务原则，为用户提供精准详实的相似性检测结果，呈现多版本、多维度的检测报告。同时，万方数据文献相似性检测服务践行专业场景化服务的建设原则，其系列产品可有效为科研管理、教育教学、出版发行、人事管理等各领域的学术个体或学术机构提供学术成果相似性检测服务。
              </div>
          </li>
          <li>
              <div class="q">中国学位论文全文数据库的特色</div>
              <div class="a">
                  万方数据依托中国科技信息研究所作为国家法定学位论文收藏单位的优势，建立了独特的学位论文数据库。该数据库收录了我国自然科学和社会科学各领域的硕士、博士及博士后研究生论文的文摘及全文信息，从侧面展示了中国研究生教育的庞大阵容以及中国科学研究的整体水平和巨大的发展潜力。目前收录了1980年－2019年硕士博士论文600余万篇（为市面收录最全的数字化资源厂商）。涉及全国211重点高校、中科院、工程院、农科院、医科院等机构的重点精选博硕士论文，内容涵盖理、工、农、医、人文、社科等各学科领域。
              </div>
          </li>
          <li>
              <div class="q">丰富对比文献库</div>
              <div class="a">中国学术期刊数据库<br>中国学位论文全文数据库<br>中国学术会议论文数据库<br>中国学术网页数据库<br>中国专利文献数据库<br>中国优秀报纸数据库
              </div>
          </li>
          <li>
              <div class="q">针对人群范围</div>
              <div class="a">高等教育、科研管理、学术出版、人事管理、政府公务</div>
          </li>
          <li>
              <div class="q">万方数据检测系统特点</div>
              <div class="a">检测速度快，秒出报告<br>数据库齐全，对比更全面<br>句子级正交基软聚类倒排检测算法<br>检测报告版本详细，多版本展示，多指标提示</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {  } from 'ant-design-vue'
import ContentTop from '@/components/ContentTop'
export default {
  components: {
    // ARow: Row,
    // ACol: Col,
    ContentTop
  },
  data () {
    return {
      row: [{ blue: require('../assets/images/prd_wfty.png'), checkpass: require('../assets/images/checkpass0.png') }, { blue: require('../assets/images/prd_wfmd.png'), checkpass: require('../assets/images/checkpass1.png') }, { blue: require('../assets/images/prd_xsys.png'), checkpass: require('../assets/images/checkpass2.png') }, { blue: require('../assets/images/prd_kczy.png'), checkpass: require('../assets/images/checkpass3.png') }, { blue: require('../assets/images/prd_wfbd.png'), checkpass: require('../assets/images/checkpass4.png') }],
      bglist: [
        {
          title: '25.00元/10000字',
          content: '学术预审版',
          details: ' 学术预审 定稿使用',
        },
        {
          title: '50.00元/10000字',
          content: '课程作业版',
          details: ' 课程作业 定稿使用',
        }
      ],
      carouselArr: [require('../assets/images/product_2.png'), require('../assets/images/product_3.png'),],
    }
  },

}
</script>

<style lang="less" scoped>
.main {
  background-color: #fafafa;
  position: relative;
  z-index: 1000;
  padding: 30px 20px;
}
.query {
  text-align: left;
  ul li {
    margin-bottom: 30px;
    .q {
    font-size: 16px;
    color: #006dbf;
    font-weight: 700;
    line-height: 32px;
    }
    .a {
    font-size: 14px;
    color: #666;
    line-height: 28px;
    }
  }
}


</style>